import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.ba-cta-hero__splide' ).length ) {
        $( '.ba-cta-hero__splide' ).each( function( index, element ) {
          new Splide( element, {
            type: 'fade',
            arrows: false,
            pagination: false,
            autoplay: true,
            interval: 4000,
            rewind: true,
            pauseOnHover: false,
            pauseOnFocus: false,
          } ).mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'ba-cta-hero', COMPONENT );
} )( app );
